<div class="live-banner">
  <span class="live-banner__dot"></span>
  <p class="live-banner__text" *ngIf="!isLoading; else bannerSkeleton">
    <strong class="live-banner__count">{{ animatedCount }}</strong>
    {{ "UX_TEXT.LIVE_BANNER.CONNECTED" | translate }}
    <strong class="live-banner__now">{{ "UX_TEXT.LIVE_BANNER.NOW" | translate }}</strong>
    {{ "UX_TEXT.LIVE_BANNER.NEAR_YOU" | translate }}
  </p>
</div>

<ng-template #bannerSkeleton>
  <div class="live-banner__skeleton-row">
    <span class="live-banner__skeleton live-banner__skeleton--count"></span>
    <span class="live-banner__skeleton live-banner__skeleton--text"></span>
  </div>
</ng-template>
